module.exports = __webpack_public_path__ + "static/media/IMG-9.c41724ee.jpg";